import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=5a8adca3"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"
import style0 from "./announcements.vue?vue&type=style&index=0&id=5a8adca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports